/**
 * Brand configuration — centralizes email branding values
 * sourced from environment variables. All required variables
 * must be set; missing values throw immediately rather than
 * falling back to synthetic defaults.
 */

import type { BrandConfig } from './types';

const REQUIRED_VARS = [
  'VITE_EMAIL_BRAND_NAME',
  'VITE_EMAIL_SUPPORT_EMAIL',
  'VITE_EMAIL_APP_URL',
] as const;

function requireEnvVar(name: string, fallback: string | undefined): string {
  const value = import.meta.env[name] ?? fallback;
  if (!value || typeof value !== 'string' || value.trim() === '') {
    throw new Error(
      `${name} is not set. Email branding cannot be configured without it. ` +
      `Add ${name} to your .env file.`,
    );
  }
  return value;
}

export function getBrandConfig(): BrandConfig {
  for (const name of REQUIRED_VARS) {
    requireEnvVar(name, undefined);
  }

  return {
    name: import.meta.env.VITE_EMAIL_BRAND_NAME!,
    logoUrl: import.meta.env.VITE_EMAIL_LOGO_URL ?? '',
    primaryColor: import.meta.env.VITE_EMAIL_PRIMARY_COLOR ?? '#0f172a',
    supportEmail: import.meta.env.VITE_EMAIL_SUPPORT_EMAIL!,
    applicationUrl: import.meta.env.VITE_EMAIL_APP_URL!,
    socialLinks: [],
  };
}
